import type { CompanyClientStatusApi } from '@/modules/companies/types';

export const companyClientStatuses = [
  'Prospect',
  'Active',
  'Inactive',
] as const satisfies readonly CompanyClientStatusApi[];

export const companyClientStatusLabels: Record<CompanyClientStatusApi, string> =
  {
    Prospect: 'Prospect',
    Active: 'Active client',
    Inactive: 'Inactive client',
  };

export const companyClientStatusOptions: Array<{
  value: CompanyClientStatusApi;
  label: string;
}> = companyClientStatuses.map((status) => ({
  value: status,
  label: companyClientStatusLabels[status],
}));

const companyClientStatusSet = new Set<string>(companyClientStatuses);

export function isCompanyClientStatus(
  value: string,
): value is CompanyClientStatusApi {
  return companyClientStatusSet.has(value);
}

export function normalizeCompanyClientStatuses(
  values: readonly string[],
): CompanyClientStatusApi[] | undefined {
  const statuses = [
    ...new Set(
      values.map((value) => value.trim()).filter(isCompanyClientStatus),
    ),
  ];

  return statuses.length > 0 ? statuses : undefined;
}

export function parseCompanyClientStatuses(
  value: string | null,
): CompanyClientStatusApi[] | undefined {
  return value ? normalizeCompanyClientStatuses(value.split(',')) : undefined;
}
